import { planTypes } from '../constant';

export const getPlanTypeByCategory = category => {
  const isPro = /^(zo)?(_)?pro/i,
    isBiz = /^biz/i,
    isHcPro = /^hc_pro/i,
    isHcBiz = /^hc_biz/i,
    isEnterprise = /^(bundle|zoent|ent)/i,
    isEducation = /^(education|edu_site|zoneduschcmp|zonedu)/i,
    isEventSaas = /^zeud(\d+)?$/i,
    isEventSaasConsumption = /^zecco(\d+)?$/i,
    isEventSaasCore = /^zecsu(\d+)?$/i,
    isEventSaasCoreConsumption = /^zeco(\d+)?$/i,
    isAdditionalCoEditor = /^(zeace|zecace)$/i,
    isAdditionalHost = /^(zeah|zecah)$/i,
    isScheduler = /^(zsched|zm_sched)/i,
    isWebinar = /^(wbn|webinar)$/i;

  if (
    isPro.test(category) ||
    isHcPro.test(category) ||
    isHcBiz.test(category) ||
    isBiz.test(category) ||
    isEducation.test(category) ||
    isEnterprise.test(category)
  ) {
    return planTypes.ZOOM_MEETING;
  }

  if (isEventSaasCore.test(category) || isEventSaasCoreConsumption.test(category)) {
    return planTypes.EVENT_SAAS_CORE;
  }

  if (isEventSaas.test(category) || isEventSaasConsumption.test(category)) {
    return planTypes.EVENT_SAAS;
  }

  if (isAdditionalCoEditor.test(category)) {
    return planTypes.ADDITIONAL_CO_EDITOR;
  }

  if (isAdditionalHost.test(category)) {
    return planTypes.ADDITIONAL_HOST;
  }

  if (isScheduler.test(category)) {
    return planTypes.ZOOM_SCHEDULER;
  }

  if (isWebinar.test(category)) {
    return planTypes.WEBINAR;
  }
};
